<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span><i>To the memory of three great naturalists of web-building spiders:</i></p>
<p class="dedf">R<span class="sm">EV.</span> H<span class="sm">.</span> C<span class="sm">.</span> M<span class="sm">C</span>C<span class="sm">OOK,</span> M<span class="sm">AJ.</span> R<span class="sm">.</span> W<span class="sm">.</span> G<span class="sm">.</span> H<span class="sm">INGSTON,</span> <i>and</i> E<span class="sm">.</span> N<span class="sm">IELSEN</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-eberhard-0006.vue?1533a09c